// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/diagramDotBg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* gray11*/
.graphWrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  -webkit-user-select: none;
          user-select: none;
  overflow: hidden;
  transition: opacity 0.2s ease 0s;
  touch-action: none;
  background-color: rgb(255, 255, 255);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.graphToolbar {
  flex: 0 1;
}

.graphSvg {
  width: 100%;
  min-height: 600px;
  flex-grow: 1;
}

.node:hover rect,
.node:hover polygon {
  filter: url("#brightness");
}
.node text {
  fill: #333;
  font-size: 13px;
  pointer-events: none;
}
.node circle,
.node polygon {
  stroke: #333;
  fill: #fff;
  stroke-width: 0.6px;
}
.node rect {
  rx: 5px;
  ry: 5px;
}
.node.type-SUB_WORKFLOW rect {
  stroke-width: 5px;
}
.node.type-TERMINATE rect {
  fill: rgb(32, 86, 104);
}
.node.type-TERMINATE text {
  fill: #fff;
}
.node.type-TERMINAL circle {
  stroke: #333;
  fill: #eee;
  stroke-width: 0.6px;
}
.node.type-TERMINAL text {
  color: #333;
  font-weight: bold;
}
.node.type-TERMINAL.dimmed circle {
  stroke: #c8c8c8;
}
.node.dimmed.bar rect {
  stroke: #c8c8c8 !important;
  fill: #c8c8c8;
}
.node.dimmed text {
  fill: #c8c8c8;
}
.node.dimmed rect,
.node.dimmed polygon,
.node.dimmed circle {
  fill: #fff;
  stroke: #c8c8c8;
}
.node.dimmed .rectMain,
.node.dimmed .switch_main-bord {
  border: 3px solid #c8c8c8 !important;
  border-radius: 20px;
}
.node.dimmed .foreignName,
.node.dimmed .foreignRef {
  color: #c8c8c8 !important;
}
.node.dimmed .back_blue {
  background-color: #205668 !important;
}
.node.dimmed .rectMain,
.node.dimmed .switch_main-bord,
.node.dimmed .back_blue,
.node.dimmed .terminal_ui {
  opacity: 0.75;
  filter: grayscale(0.75);
}
.node.status_COMPLETED.bar rect {
  stroke: #20b000 !important;
  fill: #20b000;
}
.node.status_COMPLETED text {
  fill: #20b000;
}
.node.status_COMPLETED rect,
.node.status_COMPLETED polygon,
.node.status_COMPLETED circle {
  fill: #aee1b8;
  stroke: #20b000;
}
.node.status_COMPLETED .rectMain,
.node.status_COMPLETED .switch_main-bord {
  border: 3px solid #20b000 !important;
  border-radius: 20px;
}
.node.status_COMPLETED_WITH_ERRORS.bar rect {
  stroke: #8b5b02 !important;
  fill: #8b5b02;
}
.node.status_COMPLETED_WITH_ERRORS text {
  fill: #8b5b02;
}
.node.status_COMPLETED_WITH_ERRORS rect,
.node.status_COMPLETED_WITH_ERRORS polygon,
.node.status_COMPLETED_WITH_ERRORS circle {
  fill: #feeac5;
  stroke: #8b5b02;
}
.node.status_COMPLETED_WITH_ERRORS .rectMain,
.node.status_COMPLETED_WITH_ERRORS .switch_main-bord {
  border: 3px solid #8b5b02 !important;
  border-radius: 20px;
}
.node.status_IN_PROGRESS.bar rect {
  stroke: #c2920d !important;
  fill: #c2920d;
}
.node.status_IN_PROGRESS text {
  fill: #c2920d;
}
.node.status_IN_PROGRESS rect,
.node.status_IN_PROGRESS polygon,
.node.status_IN_PROGRESS circle {
  fill: #fff5da;
  stroke: #c2920d;
}
.node.status_IN_PROGRESS .rectMain,
.node.status_IN_PROGRESS .switch_main-bord {
  border: 3px solid #c2920d !important;
  border-radius: 20px;
}
.node.status_SCHEDULED.bar rect {
  stroke: #ffb000 !important;
  fill: #ffb000;
}
.node.status_SCHEDULED text {
  fill: #ffb000;
}
.node.status_SCHEDULED rect,
.node.status_SCHEDULED polygon,
.node.status_SCHEDULED circle {
  fill: #cbe2f7;
  stroke: #ffb000;
}
.node.status_SCHEDULED .rectMain,
.node.status_SCHEDULED .switch_main-bord {
  border: 3px solid #ffb000 !important;
  border-radius: 20px;
}
.node.status_CANCELED.bar rect {
  stroke: #26194b !important;
  fill: #26194b;
}
.node.status_CANCELED text {
  fill: #26194b;
}
.node.status_CANCELED rect,
.node.status_CANCELED polygon,
.node.status_CANCELED circle {
  fill: #ded5f8;
  stroke: #26194b;
}
.node.status_CANCELED .rectMain,
.node.status_CANCELED .switch_main-bord {
  border: 3px solid #26194b !important;
  border-radius: 20px;
}
.node.status_FAILED.bar rect, .node.status_FAILED_WITH_TERMINAL_ERROR.bar rect, .node.status_TIMED_OUT.bar rect, .node.status_DF_PARTIAL.bar rect {
  stroke: #b00020 !important;
  fill: #b00020;
}
.node.status_FAILED text, .node.status_FAILED_WITH_TERMINAL_ERROR text, .node.status_TIMED_OUT text, .node.status_DF_PARTIAL text {
  fill: #b00020;
}
.node.status_FAILED rect,
.node.status_FAILED polygon,
.node.status_FAILED circle, .node.status_FAILED_WITH_TERMINAL_ERROR rect,
.node.status_FAILED_WITH_TERMINAL_ERROR polygon,
.node.status_FAILED_WITH_TERMINAL_ERROR circle, .node.status_TIMED_OUT rect,
.node.status_TIMED_OUT polygon,
.node.status_TIMED_OUT circle, .node.status_DF_PARTIAL rect,
.node.status_DF_PARTIAL polygon,
.node.status_DF_PARTIAL circle {
  fill: #f9c6c9;
  stroke: #b00020;
}
.node.status_FAILED .rectMain,
.node.status_FAILED .switch_main-bord, .node.status_FAILED_WITH_TERMINAL_ERROR .rectMain,
.node.status_FAILED_WITH_TERMINAL_ERROR .switch_main-bord, .node.status_TIMED_OUT .rectMain,
.node.status_TIMED_OUT .switch_main-bord, .node.status_DF_PARTIAL .rectMain,
.node.status_DF_PARTIAL .switch_main-bord {
  border: 3px solid #b00020 !important;
  border-radius: 20px;
}
.node.status_SKIPPED.bar rect {
  stroke: gray !important;
  fill: gray;
}
.node.status_SKIPPED text {
  fill: gray;
}
.node.status_SKIPPED rect,
.node.status_SKIPPED polygon,
.node.status_SKIPPED circle {
  fill: #fff;
  stroke: gray;
}
.node.status_SKIPPED .rectMain,
.node.status_SKIPPED .switch_main-bord {
  border: 3px solid gray !important;
  border-radius: 20px;
}
.node.status_DF_PARTIAL.bar rect {
  stroke: #b00020 !important;
  fill: #b00020;
}
.node.status_DF_PARTIAL text {
  fill: #b00020;
}
.node.status_DF_PARTIAL rect,
.node.status_DF_PARTIAL polygon,
.node.status_DF_PARTIAL circle {
  fill: #f9c6c9;
  stroke: #b00020;
}
.node.status_DF_PARTIAL .rectMain,
.node.status_DF_PARTIAL .switch_main-bord {
  border: 3px solid #b00020 !important;
  border-radius: 20px;
}
.node.status_SELECTED.bar rect {
  stroke: #b00020 !important;
  fill: #b00020;
}
.node.status_SELECTED text {
  fill: #b00020;
}
.node.status_SELECTED rect,
.node.status_SELECTED polygon,
.node.status_SELECTED circle {
  fill: #f9c6c9;
  stroke: #b00020;
}
.node.status_SELECTED .rectMain,
.node.status_SELECTED .switch_main-bord {
  border: 3px solid #b00020 !important;
  border-radius: 20px;
}
.node.selected.bar rect {
  stroke: var(--theme-primary) !important;
  fill: var(--theme-primary);
}
.node.selected text {
  fill: var(--theme-primary);
}
.node.selected rect,
.node.selected polygon,
.node.selected circle {
  fill: #fff;
  stroke: var(--theme-primary);
}
.node.selected .rectMain,
.node.selected .switch_main-bord {
  border: 3px solid var(--theme-primary) !important;
  border-radius: 20px;
}

.node.bar {
  /*
    &.type-EXCLUSIVE_JOIN {
      rect {
        stroke: \$dark-color;
        fill: #fff;
        stroke-width: \$outline-width;
      }
      rect.underline {
        stroke-width: 0;
        fill: \$dark-color;
      }
      text {
        fill: \$dark-color;
      }
      &.dimmed {
        rect {
          stroke: \$light-color;
          fill: #fff;        
        }
        text {
          fill: \$light-color;
        }
      }
    }
  */
}
.node.bar.type-FORK_JOIN_DYNAMIC rect {
  stroke: #333;
  stroke-width: 5;
  stroke-dasharray: 10;
}
.node.bar.type-FORK_JOIN_DYNAMIC.dimmed rect {
  stroke: #c8c8c8;
}
.node.bar rect {
  rx: 0px;
  ry: 0px;
  stroke-width: 0;
  fill: #333;
}
.node.bar text {
  fill: #fff;
}
.node.bar.dimmed rect {
  fill: #c8c8c8;
}

.edgePath path {
  marker-end: url(#endarrow);
  stroke: #333;
  stroke-width: 1px;
}
.edgePath.reverse path {
  marker-end: none;
  marker-start: url(#startarrow);
}
.edgePath.dimmed path {
  stroke: #c8c8c8;
  stroke-dasharray: 5;
  marker-end: url(#endarrow-dimmed);
}
.edgePath.dimmed marker {
  fill: #c8c8c8;
}
.edgePath.dimmed.reverse path {
  marker-end: none;
  marker-start: url(#startarrow-dimmed);
}
.edgePath.executed path {
  stroke: #40ba56;
  stroke-width: 2px;
}

.edgeLabel {
  fill: blue;
  font-size: 12px;
}
.edgeLabel.dimmed text {
  fill: #c8c8c8;
}

.back_blue {
  background-color: rgb(32, 86, 104) !important;
  color: #fff;
}

.type-LABEL,
.type-LABEL_FORK,
.type-LABEL_END_OF_FORK_JOIN,
.type-LABEL_END_OF_SWITCH,
.type-LABEL_START_TRIGGER_APPROVAL,
.type-LABEL_END_TRIGGER_APPROVAL,
.type-LABEL_DEFAULT,
.type-TERMINAL {
  pointer-events: none;
}

.addbtn {
  pointer-events: all;
}

.rectMain {
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  cursor: pointer;
  transition: box-shadow 250ms ease 40ms;
  background-color: white;
  border: 3px solid transparent;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 20px;
}
.rectMain--LABEL, .rectMain--LABEL_DEFAULT, .rectMain--LABEL_SWITCH-CASE, .rectMain--LABEL_FORK, .rectMain--LABEL_END_OF_SWITCH, .rectMain--LABEL_END_OF_DO_WHILE, .rectMain--LABEL_START_TRIGGER_APPROVAL, .rectMain--LABEL_END_TRIGGER_APPROVAL, .rectMain--LABEL_END_OF_FORK_JOIN {
  pointer-events: none;
  background: #ebebeb;
  border: 2px dashed #989898;
  border-radius: 50px;
}
.rectMain .foreignName {
  display: block;
  text-align: start;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: absolute;
  top: 10%;
  font-size: 16px;
  font-weight: 600;
  width: 50%;
}
.rectMain .foreignRef {
  color: rgb(170, 170, 170);
  display: block;
  text-align: start;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: absolute;
  top: 32%;
  font-size: 14px;
  font-weight: 500;
  width: 88%;
}
.rectMain .foreignTag {
  position: absolute;
  top: 11px;
  right: 11px;
  height: fit-content;
  padding: 4px 8px;
  font-size: 0.8em;
  background: rgb(221, 221, 221);
  color: black;
  border-radius: 5px;
  margin-left: 8px;
}

.switch_main_title {
  font-size: 14px;
  font-weight: 600;
  width: 80%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
}

.bar {
  background-color: rgb(32, 86, 104) !important;
  color: #fff;
  padding: 5px 20px;
}
.bar .foreignTag {
  top: 15px;
}

.selected {
  fill: red !important;
}

.trigger-approval-border {
  stroke: "black" !important;
}

.trigger-approval-rect {
  position: relative;
  z-index: -1;
}

.subworkflow-border {
  stroke: "black" !important;
}

.subworkflow-rect {
  position: relative;
  z-index: -1;
}`, "",{"version":3,"sources":["webpack://./src/components/diagram/diagram.scss"],"names":[],"mappings":"AAEA,UAAA;AAOA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EAEA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,oCAAA;EACA,yDAAA;AARF;;AAWA;EACE,SAAA;AARF;;AAWA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;AARF;;AAuCI;;EAEE,0BAAA;AApCN;AAwCE;EACE,UAnES;EAoET,eAAA;EACA,oBAAA;AAtCJ;AA0CE;;EAEE,YA3ES;EA4ET,UAzEI;EA0EJ,mBAxEY;AAgChB;AA2CE;EACE,OAAA;EACA,OAAA;AAzCJ;AA6CI;EACE,iBAAA;AA3CN;AAgDI;EACE,sBAAA;AA9CN;AAiDI;EACE,UA9FE;AA+CR;AAoDI;EACE,YAvGO;EAwGP,UAAA;EACA,mBAAA;AAlDN;AAqDI;EACE,WA7GO;EA8GP,iBAAA;AAnDN;AAsDI;EACE,eAjHQ;AA6Dd;AA5BI;EACE,0BAAA;EACA,aAnCQ;AAiEd;AA1BE;EACE,aAxCU;AAoEd;AAzBE;;;EAGE,UAfiC;EAgBjC,eA/CU;AA0Ed;AAxBE;;EAEE,oCAAA;EACA,mBAAA;AA0BJ;AAyCI;;EAEE,yBAAA;AAvCN;AA0CI;EACE,oCAAA;AAxCN;AA2CI;;;;EAIE,aAAA;EACA,uBAAA;AAzCN;AA5DI;EACE,0BAAA;EACA,aA0GiB;AA5CvB;AA1DE;EACE,aAqGmB;AAzCvB;AAzDE;;;EAGE,aA+F4B;EA9F5B,eA8FmB;AAnCvB;AAxDE;;EAEE,oCAAA;EACA,mBAAA;AA0DJ;AA9EI;EACE,0BAAA;EACA,aA8GiB;AA9BvB;AA5EE;EACE,aAyGmB;AA3BvB;AA3EE;;;EAGE,aAmG4B;EAlG5B,eAkGmB;AArBvB;AA1EE;;EAEE,oCAAA;EACA,mBAAA;AA4EJ;AAhGI;EACE,0BAAA;EACA,aAkHiB;AAhBvB;AA9FE;EACE,aA6GmB;AAbvB;AA7FE;;;EAGE,aAuG4B;EAtG5B,eAsGmB;AAPvB;AA5FE;;EAEE,oCAAA;EACA,mBAAA;AA8FJ;AAlHI;EACE,0BAAA;EACA,aAwHiB;AAJvB;AAhHE;EACE,aAmHmB;AADvB;AA/GE;;;EAGE,aA6G4B;EA5G5B,eA4GmB;AAKvB;AA9GE;;EAEE,oCAAA;EACA,mBAAA;AAgHJ;AApII;EACE,0BAAA;EACA,aA4HiB;AAUvB;AAlIE;EACE,aAuHmB;AAavB;AAjIE;;;EAGE,aAiH4B;EAhH5B,eAgHmB;AAmBvB;AAhIE;;EAEE,oCAAA;EACA,mBAAA;AAkIJ;AAtJI;EACE,0BAAA;EACA,aAqIiB;AAmBvB;AApJE;EACE,aAgImB;AAsBvB;AAnJE;;;;;;;;;EAGE,aA0H4B;EAzH5B,eAyHmB;AAkCvB;AAxJE;;;;;EAEE,oCAAA;EACA,mBAAA;AA6JJ;AAjLI;EACE,uBAAA;EACA,UAyIiB;AA0CvB;AA/KE;EACE,UAoImB;AA6CvB;AA9KE;;;EAGE,UAfiC;EAgBjC,YA6HmB;AAmDvB;AA7KE;;EAEE,iCAAA;EACA,mBAAA;AA+KJ;AAnMI;EACE,0BAAA;EACA,aA+IiB;AAsDvB;AAjME;EACE,aA0ImB;AAyDvB;AAhME;;;EAGE,aAoI4B;EAnI5B,eAmImB;AA+DvB;AA/LE;;EAEE,oCAAA;EACA,mBAAA;AAiMJ;AArNI;EACE,0BAAA;EACA,aAqJiB;AAkEvB;AAnNE;EACE,aAgJmB;AAqEvB;AAlNE;;;EAGE,aA0I4B;EAzI5B,eAyImB;AA2EvB;AAjNE;;EAEE,oCAAA;EACA,mBAAA;AAmNJ;AAvOI;EACE,uCAAA;EACA,0BA2JiB;AA8EvB;AArOE;EACE,0BAsJmB;AAiFvB;AApOE;;;EAGE,UAfiC;EAgBjC,4BA+ImB;AAuFvB;AAnOE;;EAEE,iDAAA;EACA,mBAAA;AAqOJ;;AAxFA;EAeE;;;;;;;;;;;;;;;;;;;;;;;;GAAA;AAqGF;AAlHI;EACE,YAtMO;EAuMP,eAAA;EACA,oBAAA;AAoHN;AAhHM;EACE,eA5MM;AA8Td;AApFE;EACE,OAAA;EACA,OAAA;EACA,eAAA;EACA,UA/OS;AAqUb;AAnFE;EACE,UAhPI;AAqUR;AAjFI;EACE,aAvPQ;AA0Ud;;AA7EE;EACE,0BAAA;EACA,YAhQS;EAiQT,iBAAA;AAgFJ;AA5EI;EACE,gBAAA;EACA,8BAAA;AA8EN;AAzEI;EACE,eA5QQ;EA6QR,mBAAA;EACA,iCAAA;AA2EN;AAxEI;EACE,aAlRQ;AA4Vd;AArEI;EACE,gBAAA;EACA,qCAAA;AAuEN;AAlEI;EACE,eAAA;EACA,iBAAA;AAoEN;;AA/DA;EACE,UAnSiB;EAoSjB,eAAA;AAkEF;AAhEE;EACE,aA1SU;AA4Wd;;AA9DA;EACE,6CAAA;EACA,WA9SM;AA+WR;;AA1DA;;;;;;;;EAQE,oBAAA;AA6DF;;AA1DA;EACE,mBAAA;AA6DF;;AA1DA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;EACA,uBAAA;EACA,6BAAA;EACA,2CAAA;AA6DF;AA3DE;EASE,oBAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;AAqDJ;AAlDE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AAoDJ;AAjDE;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AAmDJ;AAhDE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAkDJ;;AA9CA;EACE,eAAA;EACA,gBAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAiDF;;AA9CA;EACE,6CAAA;EACA,WApZM;EAqZN,iBAAA;AAiDF;AA/CE;EACE,SAAA;AAiDJ;;AA7CA;EACE,oBAAA;AAgDF;;AAzCA;EAGE,0BAAA;AA0CF;;AAvCA;EACE,kBAAA;EACA,WAAA;AA0CF;;AArCA;EAGE,0BAAA;AAsCF;;AAnCA;EACE,kBAAA;EACA,WAAA;AAsCF","sourcesContent":["$dark-color: #333;\n$light-color: #c8c8c8;\n/* gray11*/\n$white: #fff;\n$edge-label-color: blue;\n$outline-width: 0.6px;\n$node-text-size: 12px;\n$dimmed-background: #205668;\n\n.graphWrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  user-select: none;\n\n  overflow: hidden;\n  transition: opacity 0.2s ease 0s;\n  touch-action: none;\n  background-color: rgb(255, 255, 255);\n  background-image: url(\"../../assets/diagramDotBg.svg\");\n}\n\n.graphToolbar {\n  flex: 0;\n}\n\n.graphSvg {\n  width: 100%;\n  min-height: 600px;\n  flex-grow: 1;\n}\n\n@mixin nodeColor($colorfg, $colorbg: #fff) {\n  &.bar {\n    rect {\n      stroke: $colorfg !important;\n      fill: $colorfg;\n    }\n  }\n\n  text {\n    fill: $colorfg;\n  }\n\n  rect,\n  polygon,\n  circle {\n    fill: $colorbg;\n    stroke: $colorfg;\n  }\n\n  .rectMain,\n  .switch_main-bord {\n    border: 3px solid $colorfg !important;\n    border-radius: 20px;\n  }\n}\n\n.node {\n  &:hover {\n    rect,\n    polygon {\n      filter: url(\"#brightness\");\n    }\n  }\n\n  text {\n    fill: $dark-color;\n    font-size: 13px;\n    pointer-events: none;\n  }\n\n  // rect,\n  circle,\n  polygon {\n    stroke: $dark-color;\n    fill: $white;\n    stroke-width: $outline-width;\n  }\n\n  rect {\n    rx: 5px;\n    ry: 5px;\n  }\n\n  &.type-SUB_WORKFLOW {\n    rect {\n      stroke-width: 5px;\n    }\n  }\n\n  &.type-TERMINATE {\n    rect {\n      fill: rgb(32, 86, 104);\n    }\n\n    text {\n      fill: $white;\n    }\n  }\n\n  &.type-TERMINAL {\n    circle {\n      stroke: $dark-color;\n      fill: #eee;\n      stroke-width: 0.6px;\n    }\n\n    text {\n      color: $dark-color;\n      font-weight: bold;\n    }\n\n    &.dimmed circle {\n      stroke: $light-color;\n    }\n  }\n\n  &.dimmed {\n    @include nodeColor($light-color);\n\n    .foreignName,\n    .foreignRef {\n      color: #c8c8c8 !important;\n    }\n\n    .back_blue {\n      background-color: $dimmed-background !important;\n    }\n\n    .rectMain,\n    .switch_main-bord,\n    .back_blue,\n    .terminal_ui {\n      opacity: 0.75;\n      filter: grayscale(0.75);\n    }\n  }\n\n  &.status_COMPLETED {\n    // @include nodeColor(#163e1d, #aee1b8);\n\n    @include nodeColor(#20b000, #aee1b8);\n  }\n\n  &.status_COMPLETED_WITH_ERRORS {\n    @include nodeColor(#8b5b02, #feeac5);\n  }\n\n  &.status_IN_PROGRESS {\n    @include nodeColor(#c2920d, #fff5da);\n    // @include nodeColor(#ffb000, #fff5da);\n  }\n\n  &.status_SCHEDULED {\n    // @include nodeColor(#00a5e4, #cbe2f7);\n    @include nodeColor(#ffb000, #cbe2f7);\n  }\n\n  &.status_CANCELED {\n    @include nodeColor(#26194b, #ded5f8);\n  }\n\n  &.status_FAILED,\n  &.status_FAILED_WITH_TERMINAL_ERROR,\n  &.status_TIMED_OUT,\n  &.status_DF_PARTIAL {\n    // @include nodeColor(#7f050b, #f9c6c9);\n    // @include nodeColor(#dd2222, #f9c6c9);\n    @include nodeColor(#b00020, #f9c6c9);\n  }\n\n  &.status_SKIPPED {\n    @include nodeColor(gray);\n  }\n\n  &.status_DF_PARTIAL {\n    // @include nodeColor(#7f050b, #f9c6c9);\n    // @include nodeColor(#dd2222, #f9c6c9);\n    @include nodeColor(#b00020, #f9c6c9);\n  }\n\n  &.status_SELECTED {\n    // @include nodeColor(#7f050b, #f9c6c9);\n    // @include nodeColor(#dd2222, #f9c6c9);\n    @include nodeColor(#b00020, #f9c6c9);\n  }\n\n  &.selected {\n    // filter: url(\"#dropShadow\");\n    // @include nodeColor(#3388dd);\n    @include nodeColor(var(--theme-primary));\n  }\n}\n\n.node.bar {\n  &.type-FORK_JOIN_DYNAMIC {\n    rect {\n      stroke: $dark-color;\n      stroke-width: 5;\n      stroke-dasharray: 10;\n    }\n\n    &.dimmed {\n      rect {\n        stroke: $light-color;\n      }\n    }\n  }\n\n  /*\n  &.type-EXCLUSIVE_JOIN {\n    rect {\n      stroke: $dark-color;\n      fill: #fff;\n      stroke-width: $outline-width;\n    }\n    rect.underline {\n      stroke-width: 0;\n      fill: $dark-color;\n    }\n    text {\n      fill: $dark-color;\n    }\n    &.dimmed {\n      rect {\n        stroke: $light-color;\n        fill: #fff;        \n      }\n      text {\n        fill: $light-color;\n      }\n    }\n  }\n*/\n  rect {\n    rx: 0px;\n    ry: 0px;\n    stroke-width: 0;\n    fill: $dark-color;\n  }\n\n  text {\n    fill: $white;\n  }\n\n  &.dimmed {\n    rect {\n      fill: $light-color;\n    }\n  }\n}\n\n.edgePath {\n  path {\n    marker-end: url(#endarrow);\n    stroke: $dark-color;\n    stroke-width: 1px;\n  }\n\n  &.reverse {\n    path {\n      marker-end: none;\n      marker-start: url(#startarrow);\n    }\n  }\n\n  &.dimmed {\n    path {\n      stroke: $light-color;\n      stroke-dasharray: 5;\n      marker-end: url(#endarrow-dimmed);\n    }\n\n    marker {\n      fill: $light-color;\n    }\n  }\n\n  &.dimmed.reverse {\n    path {\n      marker-end: none;\n      marker-start: url(#startarrow-dimmed);\n    }\n  }\n\n  &.executed {\n    path {\n      stroke: #40ba56;\n      stroke-width: 2px;\n    }\n  }\n}\n\n.edgeLabel {\n  fill: $edge-label-color;\n  font-size: 12px;\n\n  &.dimmed text {\n    fill: $light-color;\n  }\n}\n\n.back_blue {\n  background-color: rgb(32, 86, 104) !important;\n  color: $white;\n}\n\n// .svg_container {\n//   min-width: 500px;\n// }\n\n.type-LABEL,\n.type-LABEL_FORK,\n.type-LABEL_END_OF_FORK_JOIN,\n.type-LABEL_END_OF_SWITCH,\n.type-LABEL_START_TRIGGER_APPROVAL,\n.type-LABEL_END_TRIGGER_APPROVAL,\n.type-LABEL_DEFAULT,\n.type-TERMINAL {\n  pointer-events: none;\n}\n\n.addbtn {\n  pointer-events: all;\n}\n\n.rectMain {\n  position: relative;\n  padding: 20px;\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: box-shadow 250ms ease 40ms;\n  background-color: white;\n  border: 3px solid transparent;\n  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 20px;\n\n  &--LABEL,\n  &--LABEL_DEFAULT,\n  &--LABEL_SWITCH-CASE,\n  &--LABEL_FORK,\n  &--LABEL_END_OF_SWITCH,\n  &--LABEL_END_OF_DO_WHILE,\n  &--LABEL_START_TRIGGER_APPROVAL,\n  &--LABEL_END_TRIGGER_APPROVAL,\n  &--LABEL_END_OF_FORK_JOIN {\n    pointer-events: none;\n    background: #ebebeb;\n    border: 2px dashed #989898;\n    border-radius: 50px;\n  }\n\n  .foreignName {\n    display: block;\n    text-align: start;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    position: absolute;\n    top: 10%;\n    font-size: 16px;\n    font-weight: 600;\n    width: 50%;\n  }\n\n  .foreignRef {\n    color: rgb(170, 170, 170);\n    display: block;\n    text-align: start;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    position: absolute;\n    top: 32%;\n    font-size: 14px;\n    font-weight: 500;\n    width: 88%;\n  }\n\n  .foreignTag {\n    position: absolute;\n    top: 11px;\n    right: 11px;\n    height: fit-content;\n    padding: 4px 8px;\n    font-size: 0.8em;\n    background: rgb(221, 221, 221);\n    color: black;\n    border-radius: 5px;\n    margin-left: 8px;\n  }\n}\n\n.switch_main_title {\n  font-size: 14px;\n  font-weight: 600;\n  width: 80%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  text-align: center;\n}\n\n.bar {\n  background-color: rgb(32, 86, 104) !important;\n  color: $white;\n  padding: 5px 20px;\n\n  .foreignTag {\n    top: 15px;\n  }\n}\n\n.selected {\n  fill: red !important;\n}\n\n// .triggerApprovalTask .rectMain {\n// background-color: #e0e7f9;/\n// }\n\n.trigger-approval-border {\n  // fill: lightblue !important; /* Apply your desired fill color */\n  // stroke: none !important; /* Remove the stroke */\n  stroke: \"black\" !important;\n}\n\n.trigger-approval-rect {\n  position: relative;\n  z-index: -1;\n  // fill: lightblue !important;\n  // stroke: lightblue !important;\n}\n\n.subworkflow-border {\n  // fill: lightblue !important; /* Apply your desired fill color */\n  // stroke: none !important; /* Remove the stroke */\n  stroke: \"black\" !important;\n}\n\n.subworkflow-rect {\n  position: relative;\n  z-index: -1;\n  // fill: lightblue !important;\n  // stroke: lightblue !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
